import React, { useContext } from 'react';
import AppContext from '../../../context/AppContext';
import AdmBlogHeader from '../../../components/admin/AdminBlogs/AdmBlogHeader';
import AdmBlogList   from '../../../subscreens/admin/AdminBlogs/AdminBlogsList';
import AdmBlogForm   from '../../../subscreens/admin/AdminBlogs/AdmBlogForm';

import '../../../assets/css/admin/adminBlogs/adminblogs.css';

const AdminBlogs = () => {
  const { showBlogForm } = useContext(AppContext);

  return (
    <div className="admin-blogs-page">
      {showBlogForm ? (
        <AdmBlogForm />
      ) : (
        <>
          <AdmBlogHeader />
          <AdmBlogList />
        </>
      )}
    </div>
  );
};

export default AdminBlogs;